export default "__VITE_ASSET__c4f12c42__"